<template>
  <div class="Invoice">
    <header-box />

    <div class="invoic">
      <el-tabs v-model="pisilled" @tab-click="handleClick">
        <el-tab-pane label="已申请" name="1">
           <el-table
            ref="multipleTable"
            :data="InvoiceList"
            tooltip-effect="dark"
            height="45vh"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column label="" width="120">
              <template>
                <div>
                  <img src="../../assets/imges/prologo1.png" alt="" /></div
              ></template>
            </el-table-column>
            <el-table-column label="发票类型" width="120">
              <div>增值税发票</div>
            </el-table-column>
            <el-table-column
              prop="CreatedTime"
              label="订单时间"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="OrderNo"
              label="订单编号"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column label="订单编号开票金额" show-overflow-tooltip>
              <template slot-scope="scope">
                <div style="color: #f00">￥{{ scope.row.xy_price }}</div>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="未申请" name="2">
          <el-table
            ref="multipleTable"
            :data="InvoiceList"
            tooltip-effect="dark"
            height="45vh"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column label="" width="120">
              <template>
                <div>
                  <img src="../../assets/imges/prologo1.png" alt="" /></div
              ></template>
            </el-table-column>
            <el-table-column label="发票类型" width="120">
              <div>增值税发票</div>
            </el-table-column>
            <el-table-column
              prop="CreatedTime"
              label="订单时间"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="OrderNo"
              label="订单编号"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column label="订单编号开票金额" show-overflow-tooltip>
              <template slot-scope="scope">
                <div style="color: #f00">￥{{ scope.row.xy_price }}</div>
              </template>
            </el-table-column>
          </el-table>
          <div class="flexheader">
          <div>
            开票金额<span style="color: #f00">￥{{ invoicNumber }}</span>
          </div>
          <el-button @click="chooseIvo" type="primary" plain
            >申请开票</el-button
          >
        </div>
        </el-tab-pane>
        
      </el-tabs>
    </div>
    <el-dialog
      title="申请发票"
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose"
    >
      <div class="Invocebody">
        <div style="display: flex; margin-bottom: 1rem">
          <div style="width: 100px">发票类型:</div>
          <div>增值税发票</div>
        </div>
        <el-form
          label-position="left"
          label-width="100px"
          :model="formLabelAlign"
        >
          <el-form-item label="发票抬头:">
            <el-input v-model="formLabelAlign.Title"></el-input>
          </el-form-item>
          <el-form-item label="纳税人识别号:">
            <el-input v-model="formLabelAlign.CreditCode"></el-input>
          </el-form-item>
          <el-form-item label="开户银行:">
            <el-input v-model="formLabelAlign.BankName"></el-input>
          </el-form-item>
          <el-form-item label="银行账号:">
            <el-input v-model="formLabelAlign.BankNo"></el-input>
          </el-form-item>
          <el-form-item label="企业地址:">
            <el-input v-model="formLabelAlign.CompanyAddress"></el-input>
          </el-form-item>
          <el-form-item label="企业电话:">
            <el-input v-model="formLabelAlign.CompanyPhone"></el-input>
          </el-form-item>
        </el-form>
        <div style="display: flex; margin-bottom: 1rem">
          <div style="width: 100px">发票金额:</div>
          <div style="color: #f00">￥{{ invoicNumber }}</div>
        </div>
        <div style="display: flex; margin-bottom: 1rem">
          <div style="width: 100px">明细</div>
          <div>商品采购</div>
        </div>
        <el-form
          label-position="left"
          label-width="100px"
          :model="formLabelAlign"
        >
          <div v-if="isArea" style="display: flex; margin: 1rem 0">
            <div style="width: 100px">地址:</div>
            <area-cascader
              separator
              type="all"
              :level="1"
              style="z-index: 222"
              v-model.trim="selected"
              :data="pca"
            />
          </div>
          <el-form-item v-if="!isArea" label="地址:">
            <el-input disabled v-model="formLabelAlign.Area"></el-input>
            <span @click="editor">编辑</span>
          </el-form-item>
          <el-form-item label="详细地址:">
            <el-input v-model="formLabelAlign.Address"></el-input>
          </el-form-item>
          <el-form-item label="联系人:">
            <el-input v-model="formLabelAlign.Contacts"></el-input>
          </el-form-item>
          <el-form-item label="联系电话:">
            <el-input v-model="formLabelAlign.Phone"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="(dialogVisible = false), (invoicNumber = 0)"
          >取 消</el-button
        >
        <el-button type="primary" @click="makeInvoice">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import headerBox from "../../components/box/headerbox.vue";
import Header from "../../components/GlobalComponents/header.vue";
import { getInvoice } from "../../api/http/invoice";
import { pca, pcaa } from "area-data";
export default {
  components: {
    headerBox,
    Header,
  },
  data() {
    return {
      isArea: false, //地址添加
      selected: [], //地址显示
      pca, //地址组件数据
      invoicNumber: 0, //开票金额
      formLabelAlign: {
        Title: "", //抬头
        CreditCode: "", //纳税人识别号
        BankName: "", //开户银行
        BankNo: "", //银行账号
        CompanyAddress: "", //银行地址
        Area: "", //地址
        Address: "", //详细地址
        Contacts: "", //联系人
        Phone: "", //联系电话
      },
      dialogVisible: false, //发票申请
      pisilled: "2",
      params: {
        isbilled: false,
        page: 1,
        size: 100,
      },
      orderNos:'',//选中订单号
      InvoiceList: [], //发票列表
    };
  },
  created() {
    this.getInvoiceLis();
    this.getInvoiceDetail();
  },
  watch: {
    selected(e) {
      let province = "";
      let city = "";
      let area = "";
      for (let i = 0; i < e.length; i++) {
        for (const key in e[i]) {
          if (i == 0) {
            {
              province = e[i][key];
            }
          } else if (i == 1) {
            city = e[i][key];
          } else if (i == 2) {
            area = e[i][key];
          }
        }
      }
      this.formLabelAlign.Area = province + "-" + city + "-" + area;
    },
  },
  methods: {
    // 申请开票
    chooseIvo() {
      if (this.invoicNumber == 0) {
        this.$message({
          message: "请选择这需要开票的订单！",
          type: "success",
        });
      } else {
        this.dialogVisible = true;
      }
    },
    // 选择变化
    handleSelectionChange(val) {
      let number = 0;
      let array=[]
      val.forEach((el) => {
        number += parseFloat(el.xy_price);
        array.push(el.OrderNo)
      });
      this.orderNos=array.join(',')
      this.invoicNumber = number.toFixed(2);
    },
    // 提交发票申请
    makeInvoice() {
      // for (const key in this.formLabelAlign) {
      //   if (this.formLabelAlign[key] == "") {
      //     return this.$message({
      //       message: "请填写完完整的开票信息",
      //       type: "error",
      //     });
      //   }
      // }
      let params = {
        InvoiceType: "增值税发票",
        address: this.formLabelAlign.Address,
        area: this.formLabelAlign.Area,
        bankName: this.formLabelAlign.bankName,
        bankNo: this.formLabelAlign.DankNo,
        companyAddress: this.formLabelAlign.CompanyAddress,
        companyPhone: this.formLabelAlign.CompanyPhone,
        contacts: this.formLabelAlign.Contacts,
        creditCode: this.formLabelAlign.CreditCode,
        money: this.invoicNumber,
        orderNos: this.orderNos,
        phone: this.formLabelAlign.Phone,
        title: this.formLabelAlign.Title,
        type: 1,
      };
       getInvoice.getInvoiceDilling(params).then(res=>{
        if(res.data.code==200){
          this.$message({
            message:"申请成功!",
            type:'success'
          })
        }else{
          this.$message({
            message:"申请失败",
            type:'error'
          })
          this.getInvoiceLis()
        }
       });
    },
    //   编辑显示
    editor() {
      this.isArea = true;
    },
    //   发票信息
    getInvoiceDetail() {
      getInvoice.getDetail().then((res) => {
        if (res.data.code) {
          this.formLabelAlign = res.data.data;
        }
      });
    },
    //   对话框取消
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    //   获取发票列表
    getInvoiceLis() {
      getInvoice.getInvoiceList(this.params).then((res) => {
        if (res.data.code == 200) {
          res.data.data.map((el) => {
            el.xy_price = Number(
              (el.Amount + el.Freight - el.CouponAmount).toFixed(2)
            );
          });
          this.InvoiceList = res.data.data;
        }
      });
    },
    //   头部变化事件
    handleClick(tab, event) {
      if(this.pisilled=='2'){
        this.params.isbilled=false
      }else if(this.pisilled=='1'){
        this.params.isbilled=true
      }
      this.getInvoiceLis();

    },
  },
};
</script>
<style lang="scss" scoped>
.Invocebody {
  height: 40vh;
  overflow-y: scroll;
  overflow-x: hidden;
  //    .el-form{
  //        border: 1px solid #999;
  //        padding: 5px;
  //        margin: 5px;
  //    }
}
.el-input__inner {
  border: 1px solid #fff !important;
}
.el-input {
  border: 1px solid #fff !important;
  width: 80%;
}
.flexheader {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
  div {
    margin-right: 20%;
  }
}
.chooseClass {
  background: #12a182;
}
.flexbody {
  display: flex;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #eee;
  box-shadow: 5px 5px 5px 5px #999;
  div {
    flex: 1;
    text-align: center;
    img {
      width: 50px;
      border-radius: 5px;
    }
  }
}
.invoic {
  width: 90%;
  margin: auto;
  height: 50vh;
  margin-top: 1rem;
  border: 1px solid #eee;
}
</style>


// WEBPACK FOOTER //
// src/view/my/Invoice.vue